var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.layout)?_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1):_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1),_c('chat-plugin',{directives:[{name:"show",rawName:"v-show",value:(
      !['/publish', '/chat-history', '/', '/login', '/sign-up'].includes(
        _vm.$router.currentRoute.path
      )
    ),expression:"\n      !['/publish', '/chat-history', '/', '/login', '/sign-up'].includes(\n        $router.currentRoute.path\n      )\n    "}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }